// extracted by mini-css-extract-plugin
export var buttonContainer = "_6z-1";
export var fontSizeSelect = "_6z-3";
export var formatSelect = "_6z-2";
export var formats = "_6z-4";
export var hidden = "_6z-5";
export var icon = "_6z-6";
export var select = "_6z-0";